module.exports = __webpack_public_path__ + "static/img/contant_3.9341b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/contant_3.png
// module id = uqD1
// module chunks = 0